import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import FormTitle from '../../../form-title/FormTitle';
import WriterForm from '../writer-form/WriterForm';
import generateHexColor from '../../../../../utils/generateHexColor';
import validate from '../../../../../utils/validate';
import { writerFormYupValidation } from '../writer-form/validations';
import { addWriter } from '../../../../../redux/settings/scout/scoutSettingsActions';

import scss from './AddWriter.module.scss';

const AddWriter = () => {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const createWriterInitialValues = {
    language: '',
    writerName: '',
    writerColor: generateHexColor(),
    writerPhrase: '',
  };

  const handleCreateWriter = useCallback(
    async (values) => {
      try {
        await dispatch(addWriter(values)).then(() => {
          navigate('/settings/scout');
        });
      } catch (error) {
        console.error(error);
      }
    },
    [dispatch, navigate],
  );

  return (
    <div className={scss.pageWrapper}>
      <FormTitle title={t('addNewWriter')} />

      <Form
        initialValues={createWriterInitialValues}
        onSubmit={handleCreateWriter}
        validate={(values) => validate(values, writerFormYupValidation())}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit }) => <WriterForm handleSubmit={handleSubmit} />}
      />
    </div>
  );
};

export default memo(AddWriter);
